import React from 'react';
import { Translate } from 'core/translate';
import MathBoxGroup from './MathBoxGroup';

const FamilyFirstIneligibleMessage = ({ eligibleForInvoicePrice }) => {
  if (eligibleForInvoicePrice) {
    return null;
  }

  return (
    <MathBoxGroup className="ineligible-family-first-message">
      <Translate value="byo.page.ineligible.vehicle" />
    </MathBoxGroup>
  );
};

export default FamilyFirstIneligibleMessage;
